<template>
    <el-row>
        <el-col class="project" :xs="24" :sm="6" v-for="(item, index) in list" :key="index">
            <div class="InvestmentOrganizationProject">
                <div class="top">
                    <img src="../../../../public/static/images/IDG-logo.png" alt="" />
                    <!-- <img :src="list.logoUrl" alt="" /> -->
                </div>
                <div class="content">
                    <div class="title">
                        {{item.title}}
                    </div>
                    <div class="tag">
                        <div class="site">
                            <img src="../../../../public/static/images/site1.png" alt="">
                            <span>北京</span>

                        </div>
                        <div class="notarize">
                            <img src="../../../../public/static/images/notarize.png" alt="">
                            <span>{{item.investhobby}}</span>
                        </div>
                    </div>
                    <div class="msg">
                        <div class="msgDivLift">
                            投资人(<span>{{item.threeinvestnum}}</span>人)
                        </div>
                        <div class="msgDivRight">
                            案例(<span>{{item.investnum}}</span>)
                        </div>
                    </div>
                    <p class="content_p">
                        {{item.content}}

                    </p>
                </div>
                <div class="bottom">
                    <div class="button">
                        <div class="buttonLeft">
                            投资偏好
                        </div>
                        <div class="buttonRight">
                            投递商业企划书
                        </div>
                    </div>
                </div>
            </div>
            <!-- <InvestmentOrganizationProject :list="item" /> -->
        </el-col>

    </el-row>


</template>

<script>
    export default {
        props: {
            list: Array,
        },
        components: {},
        data() {
            return {};
        },
        created: function () {
        },
        methods: {},
    };
</script>

<style scoped>
    .InvestmentOrganizationProject {
        background-color: #ffffff;
        border-radius: 25px;
        margin-right: 18px;
        margin-bottom: 34px;
        text-align: center;
    }

    .top {
        margin: 0 auto;
        width: 97px;
        height: 76px;

    }

    .top img {
        margin-top: 20px;
        max-width: 100%;
    }

    .content {
        margin: 0 25px;
    }

    .bottom {
        margin: 0 25px;
        margin-top: 15px;
        padding-bottom: 20px;
    }

    .title {
    
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: #333333;
    }

    .tag {
        display: flex;
        justify-content: center;
        margin-top: 14px;
    }

    .site {
        margin-right: 13px;
    }

    .site span {
        margin-left: 7px;
    }

    .notarize {
        margin-left: 13px;
    }

    .notarize span {
        margin-left: 4px;
    }

    .msg {
        display: flex;
        justify-content: center;
        margin-top: 9px;
    }

    .msg div {
        background-color: #f19149;
        border-radius: 5px;
 
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        padding: 5px 13px;
    }

    .msgDivLift {
        margin-right: 11px;
    }

    .msgDivRight {
        margin-left: 11px;
    }

    .content_p {
        margin-top: 19px;
    
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #000000;
        max-height: 100px;
        overflow: hidden;
    }

    .button {
        display: flex;
        justify-content: center;
    }

    .button div {
        border-radius: 17px;
        border: solid 1px #dcdcdc;
       
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #494949;
        padding: 7px 13px;
    }

    .buttonLeft {
        margin-right: 5px;
    }

    .buttonRight {
        margin-left: 5px;
    }
</style>